import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nv-atlases',
  templateUrl: './nv-atlases.component.html',
  styles: []
})
export class NvAtlasesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-atlases/nv-atlases.component.ts